import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import styles from '../../styles.module.scss';
import { CCMClientSettingsConfig } from '../../config/CCMClientSettingsConfig';
import classNames from 'classnames';
import { OverviewRowComponent } from '../overview-row/OverviewRowComponent';

export const ClientOverviewComponent = ({ overview }) => {
  if (_.isEmpty(overview)) return null;

  const { CLIENT_OVERVIEW_LABEL_MAP, DEFAULT_LABEL, getSortedOverview } = CCMClientSettingsConfig;
  const sortedOverview = getSortedOverview(overview, CLIENT_OVERVIEW_LABEL_MAP);

  return (
    <div className={classNames(styles.overviewContainer)}>
      <h3>Client Overview</h3>
      <table>
        <tbody>
          {sortedOverview.map(key => {
            if (!Object.keys(CLIENT_OVERVIEW_LABEL_MAP).includes(key)) return null;
            return (
              <OverviewRowComponent
                key={key}
                propKey={key.toLowerCase()}
                value={overview[key]}
                label={CLIENT_OVERVIEW_LABEL_MAP[key].label || DEFAULT_LABEL}
                overviewPropertyType={CLIENT_OVERVIEW_LABEL_MAP[key].type}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

ClientOverviewComponent.propTypes = {
  overview: PropTypes.object
};
